/*
 * Иконки списка проектов — inline SVG вместо эмодзи.
 *
 * Эмодзи рисуются шрифтом системы: на Windows, Android и в Linux-браузере они
 * выглядят по-разному, не наследуют цвет темы и на тёмном фоне часто теряются.
 * SVG наследует currentColor и одинаков везде.
 */
import React from 'react';

const stroke = (size) => ({
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
});

/** Плюс — «создать проект». */
export const IconPlus = ({ size = 30 }) => (
    <svg {...stroke(size)} aria-hidden="true"><path d="M12 5v14M5 12h14" /></svg>
);

/** Кубик — метка типа документа (CAD) и превью пустой модели. */
export const IconModel = ({ size = 16 }) => (
    <svg {...stroke(size)} aria-hidden="true">
        <path d="M12 2.6l8 4.4v9.9l-8 4.5-8-4.5V7z" />
        <path d="M4 7l8 4.5L20 7M12 11.5V21" />
    </svg>
);

/** Глобус — «опубликовано в ленте». */
export const IconGlobe = ({ size = 14 }) => (
    <svg {...stroke(size)} aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3c2.5 2.7 2.5 15.3 0 18M12 3c-2.5 2.7-2.5 15.3 0 18" />
    </svg>
);

/** Сердце — лайки. */
export const IconHeart = ({ size = 14 }) => (
    <svg {...stroke(size)} aria-hidden="true">
        <path d="M12 20s-7-4.4-7-9a4 4 0 0 1 7-2.6A4 4 0 0 1 19 11c0 4.6-7 9-7 9z" />
    </svg>
);

/** Глаз — просмотры. */
export const IconEye = ({ size = 14 }) => (
    <svg {...stroke(size)} aria-hidden="true">
        <path d="M2 12s3.6-6 10-6 10 6 10 6-3.6 6-10 6-10-6-10-6z" />
        <circle cx="12" cy="12" r="2.6" />
    </svg>
);

/** Реплика — комментарии. */
export const IconComment = ({ size = 14 }) => (
    <svg {...stroke(size)} aria-hidden="true">
        <path d="M21 11.5a8 8 0 0 1-11.6 7.2L4 20l1.4-4.6A8 8 0 1 1 21 11.5z" />
    </svg>
);

/** Корзина — удаление проекта. */
export const IconTrash = ({ size = 15 }) => (
    <svg {...stroke(size)} aria-hidden="true">
        <path d="M4 7h16M10 4h4M9 7v12M15 7v12M6 7l1 13h10l1-13" />
    </svg>
);
